import type {NavigationGuardNext, RouteLocationNormalized, RouteLocationNormalizedLoaded} from "vue-router"
import {ROUTES} from "@/router/paths"
import routeTo from "@/plugins/route"
import {Capacitor} from "@capacitor/core"

export default class SignUpDisabled implements App.Middleware.Instance {
  async handle(
    to: RouteLocationNormalized,
    from: RouteLocationNormalizedLoaded,
    next: App.Middleware.Caller,
    cancel: NavigationGuardNext
  ): Promise<void> {
    if (Capacitor.isNativePlatform()) {
      return cancel(routeTo(ROUTES.LOGIN))
    }

    await next(to, from, cancel)
  }
}
